import styled from 'styled-components';
import { colors } from '../colors';

interface tabsNavProps {
  margin?: string;
  organisationtab?:boolean;
}
const TabsNav = styled.ul<tabsNavProps>`
    margin: 0;
    padding: 0 25px;
    list-style: none;
    display: flex;
    border-bottom: 1px solid ${colors.Border2};
    margin: ${({ margin }) => margin};
    @media screen and (max-width: 640px) {
		display: block;
        margin: 0px;
        padding: 0px;
  }
  ${({ organisationtab }) =>
		organisationtab &&
		`padding: 0 !important;
    `};
}
`;

export default TabsNav;
